module.exports = __webpack_public_path__ + "img/foot_active.53232b7d.png";